var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7344 13.2734C9.56437 13.2734 6.98438 10.6934 6.98438 7.52344C6.98438 4.35344 9.56437 1.77344 12.7344 1.77344C15.9044 1.77344 18.4844 4.35344 18.4844 7.52344C18.4844 10.6934 15.9044 13.2734 12.7344 13.2734ZM12.7344 3.27344C10.3944 3.27344 8.48438 5.18344 8.48438 7.52344C8.48438 9.86344 10.3944 11.7734 12.7344 11.7734C15.0744 11.7734 16.9844 9.86344 16.9844 7.52344C16.9844 5.18344 15.0744 3.27344 12.7344 3.27344Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3206 23.2734C20.9106 23.2734 20.5706 22.9334 20.5706 22.5234C20.5706 19.0734 17.0506 16.2734 12.7306 16.2734C8.41062 16.2734 4.89062 19.0734 4.89062 22.5234C4.89062 22.9334 4.55062 23.2734 4.14062 23.2734C3.73063 23.2734 3.39062 22.9334 3.39062 22.5234C3.39062 18.2534 7.58062 14.7734 12.7306 14.7734C17.8806 14.7734 22.0706 18.2534 22.0706 22.5234C22.0706 22.9334 21.7306 23.2734 21.3206 23.2734Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.525f576007b51bed5d0b26f1268469ac.svg";
export { ForwardRef as ReactComponent };